import { gql } from '@apollo/client';

export const GET_ADMIN_ATTENDANCE_DATA = gql`
  query GetAdminAttendanceData(
    $gameId: Int
    $seasonId: Int
    $subSeasons: [Int!]
  ) {
    attendance(where: { gameId: { _eq: $gameId } }) {
      id
      playerId
      teamId
    }
    rosters(where: { team: { season: { _eq: $seasonId } } }) {
      teamId
      players {
        id
      }
    }
    players(where: { lastSeason: { _in: $subSeasons } }) {
      id
      firstName
      lastName
      jersey
      jerseySecondary
      position
      positionSecondary
      rosters(limit: 1, order_by: { teamId: desc }) {
        teamId
      }
    }
  }
`;
